<script setup lang="ts">
import { computed } from 'vue';
import useDataTableFilters from '../../../composables/useDataTableFilters';

const emits = defineEmits<{
  onNewSort: [];
  onSelectAllRows: [];
}>();

const props = defineProps<{
  field: string;
  header: string;
}>();

const { activeSortField, activeSortOrder, sort } = useDataTableFilters();

const classes = computed(() => [
  'w-fit border-0 px-2 py-1 hover:bg-brand-200 hover:text-brand-500',
  {
    'bg-brand-100 text-brand-500 hover:text-brand-600': activeSortField.value === props.field,
  },
]);

const activeIcon = computed(() => {
  if (activeSortField.value !== props.field) return 'pi pi-sort-alt';
  return activeSortOrder.value === 'desc' ? 'pi pi-sort-alpha-down-alt' : 'pi pi-sort-alpha-down';
});

function onSort() {
  const isFieldActive = activeSortField.value === props.field;
  const nextOrder = isFieldActive && activeSortOrder.value === 'asc' ? 'desc' : 'asc';
  const shouldClear = isFieldActive && activeSortOrder.value === 'desc';

  if (shouldClear) {
    activeSortField.value = '';
    activeSortOrder.value = 'desc';
    sort.value = '';
  } else {
    activeSortField.value = props.field;
    activeSortOrder.value = nextOrder;
    sort.value = props.field ? `${props.field}|${nextOrder}` : '';
  }

  emits('onNewSort');
}
</script>

<template>
  <Button
    outlined
    severity="secondary"
    :class="classes"
    :icon="activeIcon"
    @click="onSort"
  />
</template>
